export default class Point {
    constructor(x, y) {
        this.x = x;
        this.y = y;
    }
}



// WEBPACK FOOTER //
// ./src/models/point.js